import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { CabsandTimesheetHistoryPage } from './cabsand-timesheet-history';

@NgModule({
  declarations: [
    CabsandTimesheetHistoryPage,
  ],
  imports: [
    IonicPageModule.forChild(CabsandTimesheetHistoryPage),
  ],
})
export class CabsandTimesheetHistoryPageModule {}



// WEBPACK FOOTER //
// ./src/pages/cabsand-timesheet-history/cabsand-timesheet-history.module.ts